import { arrayRemove, arrayUnion, serverTimestamp } from 'firebase/firestore';
import _ from 'lodash';
import { _developerAdminEmail, isLocalhost } from '../../../project/appConfiguration';
import { getAppUserAccess } from '../../auth/appUserAccessPermissions';
import { signUpEmailDirect } from '../../auth/signInActions/signUpEmail';
import { createInitials } from '../../common/dataAdjust';
import { gEnums } from '../../enums/globalEnums';
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths';
import { getClonedAppUser } from '../../firestoreData/profiles/getClonedAppUser';
import { currentHelpers } from '../../redirection/current';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";

export const _currentUserIdProp = 'currentAppUserId'
export const _currentAppUserCountsCollection = '_currentAppUserCounts'
export const _currentAppUserCountsCollection_xxx = '_currentAppUsers'
export const _appUserPresenceCollection = '_appUserPresence'
export const _appUserPresenceDoc = 'appUsers'

export const rts = {
  handleAccessClone: 'handleAccessClone',
  handleAmmend_clonedAppUser: 'handleAmmend_clonedAppUser',
  handleAmmend_fcmTokens: 'handleAmmend_fcmTokens',
  handleAmmend_myLocation: 'handleAmmend_myLocation',
  handleAmmend_newLocation: 'handleAmmend_newLocation',
  handleAmmend_notificationRequest: 'handleAmmend_notificationRequest',
  handleAmmendEventFavs: 'handleAmmendEventFavs',
  handleAppUserInfo: 'handleAppUserInfo',
  handleAppUserPageData: 'handleAppUserPageData',
  handleClone: 'handleClone',
  handleConfirm_accessCode: 'handleConfirm_accessCode',
  handleConnectToAppUser: 'handleConnectToAppUser',
  handleGet_appUserLocation: 'handleGet_appUserLocation',
  handleGet_profile: 'handleGet_profile',
  handleGetAppUserEventInfo: 'handleGetAppUserEventInfo',
  handleInit_currentAuthUser: 'handleInit_currentAuthUser',
  handleLink_appUserData: 'handleLink_appUserData',
  handleResetAccessLevel: 'handleResetAccessLevel',
  handleResponse_addToHomePage: 'handleResponse_addToHomePage',
  handleSet_appUser: 'handleSet_appUser',
  handleSet_eventAppUsers: 'handleSet_eventAppUsers',
  handleSet_tempAccessLevel: 'handleSet_tempAccessLevel',
  handleUpdateAccess: 'handleUpdateAccess',
  handleUpdateAppUserEventInfo: 'handleUpdateAppUserEventInfo',
  ...grts
}

export const appUserReducerInitialState = (initState) => {
  return { ...initState, appUsers: { current: {}, cloned: null } }
};

export const appUserReducer = (state, action) => {

  const {
    fn_cls,
    mainDb,
    mainAuth,
    database_fns,
    pathViews,
    aps_appUserSettings,
    appUser: appUser_state,
    accessConfirmed,
    appUsers,
    eventAppUsers
  } = state

  const { type, dispatch, email, appUser: appUser_action, paps_state, itemData } = action

  const { events: eventKey } = pathViews
  const { appUserCollection } = aps_appUserSettings

  const appUserAccess = appUser_state ? getAppUserAccess(null, appUser_action) : {}
  const { appUserSession } = appUserAccess ?? {}
  const { _itemKey, appUserSessionKey } = appUserSession ?? {}

  const _appUsers = { ...appUsers }

  const _accessConfirmed = eventKey ? currentHelpers.storageItem_get('accessConfirmed-' + eventKey) : accessConfirmed

  const appUser_handlers = appUserHandlers(dispatch)

  const { handleAmmend_clonedAppUser, handleSet_appUser } = appUser_handlers

  switch (type) {

    case rts.handleAmmendEventFavs:
      return { ...state, eventFavs: action.eventFavs }

    case rts.handleInit_currentAuthUser:
      // handleGet_profile()
      return { ...state, currentAuthUser: action.currentAuthUser }

    case rts.handleSet_appUser:

      const _appUser_action = { ...appUser_action }

      if (_appUser_action && _appUser_action.profileData) {
        const { eventFavs, eventFavKeys } = getFavs(_appUser_action.profileData, pathViews.events)
        _appUser_action.eventFavs = eventFavs
        _appUser_action.eventFavKeys = eventFavKeys
        if (_appUser_action.appUserAccess) {
          _appUser_action.appUserAccess.eventFavs = eventFavs
          _appUser_action.appUserAccess.eventFavKeys = eventFavKeys
        }
      }

      _appUsers.current = _appUser_action

      const _state2 = {
        ...state,
        appUsers: _appUsers,
        appUser: _appUser_action,
        appUserChecked: true,
        isDeveloper: isDeveloper(_appUser_action),
      }
      if (eventKey) { _state2.accessConfirmed = _accessConfirmed }
      if (!_state2.profileData && _appUser_action.profileData) {
        _state2.profileData = _appUser_action.profileData
      }
      return { ..._state2 }

    case rts.handleAmmend_fcmTokens:
      const { pushResult } = action
      const { notificationRequestGranted, fcmTokens } = pushResult ?? {}
      const _appUser_state = { ...appUser_state }
      if (_appUser_state && _appUser_state.appUserAccess) {
        _appUser_state.appUserAccess.fcmTokens = fcmTokens
      }
      return { ...state, notificationRequestGranted, appUser: _appUser_state, tokenAsked: true }

    case rts.handleAmmend_notificationRequest:
      return { ...state, notificationRequestGranted: action.notificationRequestGranted }

    case rts.handleConfirm_accessCode:
      currentHelpers.storageItem_set('accessConfirmed-' + eventKey, action.passcode)
      return { ...state, accessConfirmed: action.passcode }

    case rts.handleAmmend_myLocation:
      return { ...state, appUserLocation: action.location, appUserLocationGranted: action.locationGranted }

    case rts.handleAmmend_newLocation:
      return { ...state, appUserLocation: action.location }

    case rts.handleSet_eventAppUsers:
      return { ...state, eventAppUsers: action.eventAppUsers }

    case rts.handleUpdateAppUserEventInfo:
      if (state.appUser && state.appUser.appUserAccess_cloned && state.appUser.appUserAccess_cloned) {
        const _appUser = { ...state.appUser }
        _appUser.appUserAccess_cloned.appUserSession = action.result
        return { ...state, appUser: _appUser }
      }
      return state

    case rts.handleAppUserInfo:
      const { appUserInfo } = action ?? {}
      if (appUserInfo) {
        return { ...state, appUserInfo }
      }
      return state

    case rts.handleUpdateAccess:
      const _ausa = { ...appUser_state }
      const { appUserInfo: _aui } = state
      if (_ausa.appUserAccess) {
        _ausa.appUserAccess.selectedEventAccess = action.selectedEventAccess
        if (_aui) {
          _ausa.appUserAccess.affiliation = {
            type: _aui.affiliationType,
            team: _aui.team,
            _status: _aui.status,
          }
        }
      }
      return { ...state, appUser: _ausa }

    case rts.handleResponse_addToHomePage:
      return { ...state, homePageResponse: action.homePageResponse, homePageResponded: true }

    case rts.handleSet_tempAccessLevel:
      if (action.tempAccessLevel === 0 || action.tempAccessLevel === null) {
        _appUsers.cloned = null
        return { ...state, appUsers: _appUsers, isClone: false }
      } else {
        _appUsers.cloned = {
          appUserAccess: getAppAccess(action.tempAccessLevel, action.pathViews)
        }
        return { ...state, appUsers: _appUsers, isClone: true }
      }

    case rts.handleResetAccessLevel:
      _appUsers.cloned = null
      return { ...state, appUser: appUser_state, appUsers: _appUsers, isClone: false }


    case rts.handleClone:
      getClonedAppUser(fn_cls, mainDb, database_fns, itemData, paps_state, handleAmmend_clonedAppUser, eventAppUsers, aps_appUserSettings)
      return state

    case rts.handleAmmend_clonedAppUser:
      const { appUser_cloned } = action
      _appUsers.cloned = appUser_cloned
      return {
        ...state,
        appUser: appUser_state,
        appUsers: _appUsers,
        isClone: true
      }

    case rts.handleAccessClone:
      const _accessClone = state.accessClone && state.accessClone.name === action.accessClone.name ? null : action.accessClone
      return { ...state, accessClone: _accessClone }

    case rts.handleConnectToAppUser:
      return state

    case rts.handleAppUserPageData:
      return { ...state, [action.dataCollectionName]: action.dataValue }


    case rts.handleLink_appUserData:

      if (appUserSession) {

        const _appUserKey = appUserSessionKey ? appUserSessionKey : _itemKey
        const _data1 = appUserSession[action.view]
        const _dataRef1 = createRefPath_event(pathViews, [action.view, action.viewKey])
        const _dataRef2 = createRefPath_event(pathViews, [appUserCollection, _appUserKey])

        const { dataToUpdate1, dataToUpdate2 } = getDataItemToUpdate(_data1, appUserCollection, _appUserKey, action.view, action.viewKey)

        console.log('_dataRef1', _dataRef1, dataToUpdate1)
        console.log('_dataRef2', _dataRef2, dataToUpdate2)

      }
      return state

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return state
  }
}

export const appUserHandlers = (dispatch) => {

  return {
    handleAccessClone: (accessClone) => { dispatch({ type: rts.handleAccessClone, dispatch, accessClone }) },
    handleAmmend_clonedAppUser: (appUser_cloned) => { dispatch({ type: rts.handleAmmend_clonedAppUser, dispatch, appUser_cloned }) },
    handleAmmend_fcmTokens: (pushResult) => { dispatch({ type: rts.handleAmmend_fcmTokens, pushResult }) },
    handleAmmend_myLocation: (location, locationGranted) => dispatch({ type: rts.handleAmmend_myLocation, dispatch, location, locationGranted }),
    handleAmmend_newLocation: (location) => dispatch({ type: rts.handleAmmend_newLocation, dispatch, location }),
    handleAmmend_notificationRequest: (notificationRequestGranted) => { dispatch({ type: rts.handleAmmend_notificationRequest, notificationRequestGranted }) },
    handleAmmendEventFavs: (eventFavs) => { dispatch({ type: rts.handleAmmendEventFavs, dispatch, eventFavs }) },
    handleAppUserInfo: (appUserInfo) => { dispatch({ type: rts.handleAppUserInfo, dispatch, appUserInfo }) },
    handleAppUserPageData: (dataCollectionName, dataValue) => { dispatch({ type: rts.handleAppUserPageData, dispatch, dataCollectionName, dataValue }) },
    handleClone: (item, itemData, paps_state, appUserCollection) => { dispatch({ type: rts.handleClone, dispatch, item, itemData, paps_state, appUserCollection }) },
    handleConfirm_accessCode: (passcode) => dispatch({ type: rts.handleConfirm_accessCode, dispatch, passcode }),
    handleConnectToAppUser: (view, dataItem) => { dispatch({ type: rts.handleConnectToAppUser, dispatch, view, dataItem }) },
    handleGet_appUserLocation: () => { dispatch({ type: rts.handleGet_appUserLocation, dispatch }) },
    handleGetAppUserEventInfo: (forClone) => { dispatch({ type: rts.handleGetAppUserEventInfo, dispatch, forClone }) },
    handleInit_currentAuthUser: (currentAuthUser) => { dispatch({ type: rts.handleInit_currentAuthUser, dispatch, currentAuthUser }) },
    handleLink_appUserData: (view, viewKey, callback) => { dispatch({ type: rts.handleLink_appUserData, dispatch, view, viewKey, callback }) },
    handleResetAccessLevel: () => { dispatch({ type: rts.handleResetAccessLevel }) },
    handleResponse_addToHomePage: (homePageResponse) => { dispatch({ type: rts.handleResponse_addToHomePage, dispatch, homePageResponse }) },
    handleSet_appUser: (appUser, appUserAccess, userAccessRequests) => { dispatch({ type: rts.handleSet_appUser, dispatch, appUser, appUserAccess, userAccessRequests }) },
    handleSet_eventAppUsers: (eventAppUsers) => { dispatch({ type: rts.handleSet_eventAppUsers, dispatch, eventAppUsers }) },
    handleSet_tempAccessLevel: (tempAccessLevel, pathViews) => { dispatch({ type: rts.handleSet_tempAccessLevel, dispatch, tempAccessLevel, pathViews }) },
    handleUpdateAccess: (selectedEventAccess) => { dispatch({ type: rts.handleUpdateAccess, dispatch, selectedEventAccess }) },
    handleUpdateAppUserEventInfo: (result) => { dispatch({ type: rts.handleUpdateAppUserEventInfo, dispatch, result }) },
    ...responseHandlers(dispatch)
  }
}

const getAppAccess = (accessLevel, pathViews) => {
  const x = _.find(gEnums.accessLevels, { 'key': accessLevel })
  const aa = {
    accessLevel: accessLevel,
    appUserColor: x.color,
    appUserAccessType: _.camelCase(x.caption),
    clientAccessKey: pathViews ? pathViews.clients : null,
    events: pathViews ? { [pathViews.events]: true } : null,
    initials: createInitials(_.startCase(x.caption), 2),
    isAdminOrSuper: accessLevel >= gEnums.accessLevels.admin.value,
    isSuperAdmin: accessLevel >= gEnums.accessLevels.superAdmin.value,
    loggedIn: true,
    settingsAuthLevel: accessLevel > gEnums.authLevels.appSubAdmin.value ? accessLevel : 0,
  }
  console.log('aa', aa)
  return aa
}

const getFavs = (profileData, eventKey) => {
  const { pageFavs } = profileData
  const eventFavs = _.mapValues(pageFavs, (category) =>
    _.pickBy(category, (obj) =>
      obj.pathName.includes(`/events/${eventKey}/`)
    )
  );
  const eventFavKeys = _.flatMap(pageFavs, (category) =>
    _.keys(_.pickBy(category, (obj) =>
      obj.pathName.includes(`/events/${eventKey}/`)
    ))
  );
  return { eventFavs, eventFavKeys }
}

const getDataItemToUpdate = (existingData, appUserCollection, appUserKey, view, viewKey) => {

  let dataToUpdate1;
  let dataToUpdate2;

  if (existingData) {
    if (existingData.includes(viewKey)) {
      dataToUpdate1 = { [appUserCollection]: arrayRemove(appUserKey) }
      dataToUpdate2 = { [view]: arrayRemove(viewKey) }
    } else {
      dataToUpdate1 = { [appUserCollection]: arrayUnion(appUserKey) }
      dataToUpdate2 = { [view]: arrayUnion(viewKey) }
    }
  } else {
    dataToUpdate1 = { [appUserCollection]: [appUserKey] }
    dataToUpdate2 = { [view]: [viewKey] }
  }

  return { dataToUpdate1, dataToUpdate2 }

}


const isDeveloper = (appUser) => {
  return isLocalhost() && appUser && appUser.email === _developerAdminEmail ? true : false
}
